import $$ from 'cmn-utils'

const baseUrl = "/api/sys/plane-picture/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    listByUnit: (params) => {
        return $$.get(baseUrl + 'list-by-unit', params)
    },

}